export * from './actions';
export * from './mutations';
export * from './state';
export * from './getters';

export const namespaced = true;
